import { AfterViewInit, Component, ElementRef, Input, OnChanges, OnDestroy, OnInit, Renderer2, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { BehaviorSubject, Subject, of } from 'rxjs';
import { distinct, filter, map, takeUntil, tap } from 'rxjs/operators';
import { ReviewState } from 'src/app/review/models/review-state';
import { FacadeService } from 'src/app/shared/service-facade/facade.service';

@Component({
  selector: 'app-account-ownership',
  templateUrl: './account-ownership.component.html',
  styleUrls: ['./account-ownership.component.css']
})
export class AccountOwnershipComponent implements OnInit, OnDestroy, OnChanges, AfterViewInit {
  @Input() reviewState: ReviewState = ReviewState.Initial;
  @Input() isInReview: boolean = false;

  accountOwnershipForm = new FormGroup({
    isIndividual: new FormControl(true)
  });

  reviewState$: BehaviorSubject<ReviewState> = new BehaviorSubject<ReviewState>(ReviewState.Initial);

  canEdit$ = this.reviewState$.pipe(
    map(state => state === ReviewState.ReadOnly)
  );

  canEditForm$ = this.reviewState$.pipe(
    map(state =>
      state === ReviewState.Initial ||
      state === ReviewState.Edit
    )
  );

  title = "";
  ownership$ = this._facadeService.isJointApplication$.pipe(
    distinct(),
    map(isJointApplication => isJointApplication
      ? "Joint"
      : "Individual"
    )
  );

  canHaveJointAccount$ = this._facadeService.canHaveJointAccount$;

  private _destroySubject$: Subject<void> = new Subject();

  constructor(
    private _facadeService: FacadeService,
    private _elementRef: ElementRef,
    private _renderer: Renderer2,
  ) { }

  ngOnInit(): void {
    this.accountOwnershipForm.get("isIndividual")?.valueChanges
      .pipe(takeUntil(this._destroySubject$))
      .subscribe(isIndividual => {
        if (isIndividual) {
          this._facadeService.markApplicationAsIndividual();
        } else {
          this._facadeService.markApplicationAsJoint();
        }
      });

    this.canHaveJointAccount$.pipe(takeUntil(this._destroySubject$)).subscribe(value => {
      if (!value) {
        this.accountOwnershipForm.get("isIndividual")?.patchValue(true);
      }
    })

    this.accountOwnershipForm.updateValueAndValidity();
    this._updateTitle();
  }

  ngOnDestroy(): void {
    this._destroySubject$.next();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this._updateTitle();
    this.reviewState$.next(this.reviewState);
  }

  ngAfterViewInit(): void {
    const matRadioGroup = this._elementRef.nativeElement.querySelector('mat-radio-group');
    if(matRadioGroup) {
      this._renderer.removeAttribute(matRadioGroup, 'role');
    }
  }

  private _updateTitle(): void {
    this.title = this.isInReview
      ? "Account Type"
      : "Account Ownership";
  }
}
